import { Controller } from "stimulus";
import { EventCurrencyChanged, EventPriceChanged } from "../events";
import { getActiveCurrency } from "../util/currency";

export default class extends Controller {
  static targets = ["profitAndLossValue", "profitAndLossPercentage", "loading"]

  connect() {
    window.addEventListener(EventCurrencyChanged, e => {
      this._showSpinner(true);

      const overviewUrl = `/portfolio/overview?vs_currency=${getActiveCurrency()}`;

      fetch(overviewUrl, { credentials: "same-origin" })
        .then(response => response.json())
        .then(json => {
          this._updateOverview(json);
          this._showSpinner(false);
        });
    });
  }

  _updateOverview(overview) {
    this.profitAndLossValueTarget.dataset.priceBtc = overview.holdings_change_in_btc;
    this.profitAndLossValueTarget.innerText = overview.holdings_change;

    const profitAndLossPercentageTarget = this.profitAndLossPercentageTarget;
    const upClass = profitAndLossPercentageTarget.getAttribute("data-up-class");
    const downClass = profitAndLossPercentageTarget.getAttribute("data-down-class");

    if (overview.holdings_change_percentage >= 0) {
      profitAndLossPercentageTarget.classList.add(upClass);
      profitAndLossPercentageTarget.classList.remove(downClass);
      profitAndLossPercentageTarget.innerText = `(+${overview.holdings_change_percentage}%)`;
    } else {
      profitAndLossPercentageTarget.classList.add(downClass);
      profitAndLossPercentageTarget.classList.remove(upClass);
      profitAndLossPercentageTarget.innerText = `(${overview.holdings_change_percentage}%)`;
    }

    this.element.dispatchEvent(
      new CustomEvent(EventPriceChanged, {
        bubbles: true
      })
    );
  }

  _showSpinner(show) {
    if (show) {
      this.loadingTarget.classList.remove("d-none");
      this.profitAndLossValueTarget.classList.add("d-none");
      this.profitAndLossPercentageTarget.classList.add("d-none");
    } else {
      this.loadingTarget.classList.add("d-none");
      this.profitAndLossValueTarget.classList.remove("d-none");
      this.profitAndLossPercentageTarget.classList.remove("d-none");
    }
  }
}
